import { Group } from '@mantine/core';

const EmailAttachmentChip = ({ children, missing = false }) => (
  <Group
    noWrap
    spacing="xs"
    px="xs"
    py={6}
    sx={(theme) => {
      const dark = theme.colorScheme === 'dark';
      const defaultBackground = dark ? theme.colors.dark[5] : theme.colors.gray[0];
      const hoverBackground = dark ? theme.colors.dark[4] : theme.colors.gray[1];

      return {
        alignItems: 'center',
        flex: '0 1 auto',
        width: 'fit-content',
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        borderRadius: theme.radius.sm,
        backgroundColor: missing ? theme.colors.red[6] : defaultBackground,
        boxShadow: dark ? undefined : '0 1px 2px rgba(15, 23, 42, 0.05)',
        transition: 'background-color 120ms ease',
        '&:hover': {
          backgroundColor: missing ? theme.colors.red[7] : hoverBackground,
        },
      };
    }}
  >
    {children}
  </Group>
);

export default EmailAttachmentChip;
